import { ActionIcon, Tooltip, type MantineBreakpoint } from "@mantine/core";
import { IconSun, IconMoon } from "@tabler/icons-react";
import { useColorSchemeToggle } from "../hooks/useColorSchemeToggle";
import commonClasses from "../styles/common.module.css";

export function ColorSchemeToggle({
  visibleFrom,
}: {
  /**
   * Hold the icon back until this breakpoint. The app header passes `md`: an
   * 11" iPad in portrait (820–834px) sits below it and cannot afford the 46px
   * this icon costs, so the toggle moves into the launcher menu there instead.
   * Omitted elsewhere, which leaves the admin/auditor headers unchanged.
   */
  visibleFrom?: MantineBreakpoint;
} = {}) {
  const { computed, label, toggle } = useColorSchemeToggle();

  return (
    <Tooltip label={label}>
      <ActionIcon
        className={commonClasses.touchTarget}
        onClick={toggle}
        variant="subtle"
        size="lg"
        aria-label="Toggle color scheme"
        visibleFrom={visibleFrom}
      >
        {computed === "dark" ? (
          <IconSun size={20} stroke={1.5} />
        ) : (
          <IconMoon size={20} stroke={1.5} />
        )}
      </ActionIcon>
    </Tooltip>
  );
}
